import { render, staticRenderFns } from "./PrettyXml.vue?vue&type=template&id=68819816&"
import script from "./PrettyXml.vue?vue&type=script&lang=js&"
export * from "./PrettyXml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports